import(/* webpackMode: "eager" */ "/data/www/vetopedia.org/frontend/app/[lang]/pharma-medizinopfer/[id]/page.tsx");
